"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.constructor");
var _userCenter = require("@/api/userCenter/userCenter");
var _childrenUserManage = require("@/api/userCenter/childrenUserManage");
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "userCenter",
  data: function data() {
    var _this = this;
    var validateAccountName = function validateAccountName(rule, value, callback) {
      if (_this.userInfo.accountName !== '') {
        (0, _childrenUserManage.accountNameExist)({
          sysAccountId: _this.userInfo.sysAccountId,
          accountName: _this.userInfo.accountName
        }).then(function (response) {
          var i = response.success;
          i === false ? callback(new Error(_this.$t('userCenter.userInfo.accountNameExist'))) : callback();
        });
      } else {
        callback(_this.$t('userCenter.userInfo.accountNameISNull'));
      }
    };
    var validateNewPwd = function validateNewPwd(rule, value, callback) {
      if (value) {
        var passwordRule = new RegExp('^(?=.*[a-zA-Z])(?=.*\\d).{8,30}$');
        var passwordRule2 = /[`~^*()_\-+=<>?:"{}|,.\/;'\\[\]·！￥（——）：；“”‘、，|《。》？、【】[\]]/;
        var isValidTest = passwordRule.test(value);
        var isValidTest2 = passwordRule2.test(value);
        if (value === '') {
          callback(new Error(_this.$t('userCenter.userInfo.passwordRules')));
        }
        if (!isValidTest) {
          callback(new Error(_this.$t('userCenter.userInfo.passwordRules1')));
        }
        if (isValidTest2) {
          callback(new Error(_this.$t('userCenter.userInfo.passwordRules2')));
        }
        callback();
      } else {
        callback();
      }
    };
    var validateConfirPwd = function validateConfirPwd(rule, value, callback) {
      if (_this.resetPasswordForm.password && !value) {
        callback(new Error(_this.$t('userCenter.userInfo.confirmPasswordRules')));
      }
      if (value) {
        if (value === '') {
          callback(new Error(_this.$t('userCenter.userInfo.confirmPasswordRules')));
        } else if (value !== _this.resetPasswordForm.password) {
          callback(new Error(_this.$t('userCenter.userInfo.errorPasswordRules')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateEmail = function validateEmail(rule, value, callback) {
      if (value === '' || value == null) {
        callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules')));
      }
      if (value.length > 500) {
        callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules1')));
      }
      var array = value.split(";");
      for (var i = 0; i < array.length; i++) {
        if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
          callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules2')));
        }
      }
      callback();
    };
    var validateCcEmail = function validateCcEmail(rule, value, callback) {
      if (value) {
        var array = value.split(";");
        for (var i = 0; i < array.length; i++) {
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
            callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules2')));
          }
        }
        if (value === '') {
          callback(new Error(_this.$t('userCenter.userInfo.passwordRules')));
        }
        if (value.length > 500) {
          callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules1')));
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      capsTooltip: false,
      passwordType: 'password',
      passwordTypeConfirm: 'password',
      resetPasswordForm: {
        password: '',
        confirmPassword: ''
      },
      resetPasswordRules: {
        password: [{
          required: false,
          validator: validateNewPwd,
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: false,
          validator: validateConfirPwd,
          trigger: 'blur'
        }]
      },
      userInfoRules: {
        accountName: [{
          required: true,
          validator: validateAccountName,
          trigger: 'change'
        }],
        notifyToEmail: [{
          required: true,
          validator: validateEmail,
          trigger: 'blur'
        }],
        notifyCcEmail: [{
          required: false,
          validator: validateCcEmail,
          trigger: 'blur'
        }]
      },
      userInfo: this.$store.state.user.userInfo,
      isChangeEdit: false,
      firstNotifyToEmail: '',
      firstNotifyCcEmail: '',
      firstBookingViewType: '',
      dialogVisible: false,
      termContent: '',
      registerTermContent: '',
      bookingTermContent: ''
    };
  },
  watch: {
    'userInfo.accountName': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    },
    'userInfo.notifyToEmail': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    },
    'userInfo.notifyCcEmail': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    },
    'userInfo.bookingViewType': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    },
    'resetPasswordForm.password': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    },
    'resetPasswordForm.confirmPassword': {
      handler: function handler(newVal, oldVal) {
        if (this.userInfo.accountName == this.accountName && this.userInfo.bookingViewType == this.firstBookingViewType && this.userInfo.notifyCcEmail == this.firstNotifyCcEmail && this.userInfo.notifyToEmail == this.firstNotifyToEmail && !this.resetPasswordForm.password.length && !this.resetPasswordForm.confirmPassword.length) {
          this.isChangeEdit = false;
        } else {
          this.isChangeEdit = true;
        }
      }
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    this.getOldData();
    this.getLatestTerms();
  },
  methods: {
    handleOpen: function handleOpen(termType) {
      if (termType === '1') {
        this.termContent = this.registerTermContent;
      } else if (termType === '2') {
        this.termContent = this.bookingTermContent;
      }
      this.dialogVisible = true;
    },
    getLatestTerms: function getLatestTerms() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.getWebOnlineTermsByAccount)().then(function (res) {
        var terms = res.data;
        if (res.success && terms && terms.length > 0) {
          var _iterator = (0, _createForOfIteratorHelper2.default)(terms),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var term = _step.value;
              var data = _this2.language === 'en' ? term.termContentEn : term.termContent;
              var termContent = data.replace(/\r?\n/g, '<br>');
              if (term.termType === '1') {
                _this2.registerTermContent = termContent;
              } else if (term.termType === '2') {
                _this2.bookingTermContent = termContent;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    showPwd: function showPwd() {
      var _this3 = this;
      this.passwordType = '';
      this.$nextTick(function () {
        _this3.$refs.password.focus();
      });
    },
    hidePwd: function hidePwd() {
      var _this4 = this;
      this.passwordType = 'password';
      this.$nextTick(function () {
        _this4.$refs.password.focus();
      });
    },
    showPwdCon: function showPwdCon() {
      var _this5 = this;
      this.passwordTypeConfirm = '';
      this.$nextTick(function () {
        _this5.$refs.password.focus();
      });
    },
    hidePwdCon: function hidePwdCon() {
      var _this6 = this;
      this.passwordTypeConfirm = 'password';
      this.$nextTick(function () {
        _this6.$refs.password.focus();
      });
    },
    getOldData: function getOldData() {
      this.firstNotifyToEmail = this.userInfo.notifyToEmail;
      this.firstNotifyCcEmail = this.userInfo.notifyCcEmail;
      this.firstBookingViewType = this.userInfo.bookingViewType;
    },
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs.userInfoRef.validate(function (valid) {
        if (valid) {
          _this7.$refs.resetPasswordRef.validate(function (valid) {
            if (valid) {
              if (_this7.resetPasswordForm.password) {
                _this7.userInfo.password = window.btoa(_this7.resetPasswordForm.password);
                _this7.userInfo.confirmPassword = window.btoa(_this7.resetPasswordForm.confirmPassword);
              }
              _this7.loading = (0, _utils.load)();
              (0, _userCenter.ebSysAccountUpdateAccount)(_this7.userInfo).then(function (res) {
                _this7.userInfo = res.data;
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                _this7.$message({
                  type: "success",
                  message: _this7.$t('userCenter.userInfo.successMessage')
                });
                _this7.resetPasswordForm.password = '';
                _this7.resetPasswordForm.confirmPassword = '';
                _this7.getOldData();
                _this7.isChangeEdit = false;
              }).catch(function (err) {}).finally(function () {
                _this7.loading.close();
              });
            }
            return false;
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};